var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('custom-modal', {
    attrs: {
      "id": "add-user-modal",
      "size": "lg"
    },
    on: {
      "on-hidden": _vm.onHidden
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('b-overlay', {
          staticClass: "col-md-12",
          attrs: {
            "show": _vm.loading,
            "opacity": "0",
            "spinner-variant": "primary",
            "spinner-type": "grow"
          }
        }, [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/customer-project/invite-icon.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('customer-project.modal.invite.title')) + " ")]), _c('signup-form', {
          attrs: {
            "error": _vm.error
          },
          on: {
            "submit": _vm.onSubmit
          },
          scopedSlots: _vm._u([{
            key: "back",
            fn: function () {
              return [_c('b-button', {
                staticClass: "btn-back w-100",
                attrs: {
                  "variant": "white"
                },
                on: {
                  "click": _vm.close
                }
              }, [_vm._v(" " + _vm._s(_vm.$t('signup.button.back-to-login')) + " ")])];
            },
            proxy: true
          }])
        })], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }